import React from "react";

/**
 * MovieRowSkeleton — shimmer placeholder for a Browse rail while data loads.
 * Mirrors the layout of MovieRow so swapping in real content doesn't shift the page.
 */
export default function MovieRowSkeleton({ count = 8, title }) {
  const cards = Array.from({ length: count });
  return (
    <section
      className="relative mb-10"
      data-testid="movie-row-skeleton"
      aria-busy="true"
      aria-label={title ? `Loading ${title}` : "Loading row"}
    >
      <div className="flex items-center justify-between mb-3 px-6 lg:px-12">
        {title ? (
          <h2 className="text-xl md:text-2xl font-semibold text-white tracking-tight opacity-70">
            {title}
          </h2>
        ) : (
          <div className="skeleton h-6 w-44 rounded" />
        )}
        <div className="skeleton h-3 w-20 rounded" />
      </div>
      <div className="flex gap-3 overflow-hidden px-6 lg:px-12 pb-4">
        {cards.map((_, i) => (
          <div
            key={i}
            className="skeleton shrink-0 rounded-md"
            style={{ width: "240px", height: "135px" }}
          />
        ))}
      </div>
    </section>
  );
}
